import { motion } from "motion/react"
import { ReactNode } from "react"

const FadeInWhenStart = ({children, delay, classname}: {children: ReactNode, delay: number, classname?: string}) => {
    return(
        <motion.div className={classname}
                    transition={{ duration: 0.4, delay: delay }}
                    initial={{opacity: 0, translateY: '20px', bottom: '0px'}}
                    animate={{opacity: 1, translateY: '0px', bottom: '20px'}}
                    >
            {children}
        </motion.div>

    )

}

export default FadeInWhenStart;